<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M12.7 9.99974L7.30005 9.99987M10 12.6998V7.29989M16.075 9.9998C16.075 13.355 13.3552 16.0748 10 16.0748C6.64492 16.0748 3.92505 13.355 3.92505 9.9998C3.92505 6.64468 6.64492 3.9248 10 3.9248C13.3552 3.9248 16.075 6.64468 16.075 9.9998Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PlusCircleIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>
